export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'fightMatchNo',
    label: 'field.round',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'resultNumber',
    label: 'field.result',
  },
  {
    key: 'resultRang',
    label: 'field.detail',
  },
  {
    key: 'bonus',
    label: 'field.bonus',
  },
  {
    key: 'result',
    label: 'field.underOver',
  },
  {
    key: 'resultDigit',
    label: 'field.range',
  },
  {
    key: 'revenue',
    label: 'field.revenue',
    tdClass: 'text-right',
  },
  // {
  //   key: 'totalSteakUSD',
  //   label: 'field.totalSteakUSD',
  //   tdClass: 'text-right',
  // },
  // {
  //   key: 'totalSteakKHR',
  //   label: 'field.totalSteakKHR',
  //   tdClass: 'text-right',
  // },
  {
    key: 'totalSteak',
    label: 'field.totalSteak',
    tdClass: 'text-right',
  },
  {
    key: 'overUnderOutstanding',
    label: 'field.overUnderOutstanding',
  },
  {
    key: 'rangeOutstanding',
    label: 'field.rangeOutstanding',
  },
  {
    key: 'createdAt',
    label: 'field.createDate',
  },
];
